'use client';

import type { RecentSearchesProps } from '../types';
import { SearchIcon, CloseIcon } from '../icons';

export default function RecentSearches({ searches, onSearchClick, onRemove }: RecentSearchesProps) {
  if (searches.length === 0) return null;

  return (
    <div className="flex flex-col items-start gap-2 self-stretch pb-4 border-b border-[#D8D8D8]">
      <h4 className="self-stretch text-[14px] font-medium font-gotham text-text-primary leading-[28px]">
        Αναζητήσατε πρόσφατα
      </h4>
      <ul className="flex flex-col items-start self-stretch">
        {searches.map((search, idx) => (
          <li key={idx} className="flex items-start justify-between gap-2 py-1.5 self-stretch group">
            <button
              onClick={() => onSearchClick(search)}
              className="flex items-start min-w-0 flex-1 gap-[6px] text-left text-[14px] font-gotham font-normal text-text-primary transition-colors hover:text-brand cursor-pointer"
            >
              {/* mt aligns the icon with the FIRST line of (possibly wrapping) text */}
              <SearchIcon className="w-4 h-4 flex-shrink-0 mt-[2px]" />
              <span className="min-w-0 break-words leading-[18px]">{search}</span>
            </button>
            <button
              onClick={() => onRemove(search)}
              className="flex items-center justify-center w-6 h-6 flex-shrink-0 -mr-1 text-[#6A7282] hover:text-text-primary transition-colors cursor-pointer"
              aria-label={`Remove ${search}`}
            >
              <CloseIcon className="w-3 h-3 flex-shrink-0" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
